import { p as pageLoadDataParams } from './analytics-765d4daf.js';
import { P as Protocol, S as SDL_REDESIGN_HEADER_SELECTOR, c as SDL_HEADER_SELECTOR_APC, d as SDL_HEADER_SELECTOR, e as scrollBehavior, T as TAB_BAR_HEIGHT, f as SLASH, B as BAZAAR_VOICE_URL } from './request.constants-deb285e0.js';
import { c as createCommonjsModule, a as commonjsGlobal } from './_commonjsHelpers-ba3f0406.js';

// Commerce connector API is called in all our pes pages
const ATG_COMMERCE_CONNECTOR_PATH = '/product/pdp/commerce-connector';
// Product-software is called in PDP pages for software products
const ATG_PRODUCT_SOFTWARE_PATH = '/product/api/product-software';
// product card main and secondary API is used called in range ,category listing and comparision pages.
const ATG_PRODUCT_CARD_ADDITION_PATH = '/product/api/productCard/addition';
const ATG_PRODUCT_CARD_MAIN_PATH = '/product/api/productCard/main';
// My products is called in range and pdp and also in category and subcategory listing products
const ATG_MY_PRODUCTS_REST_URL = '/product/my-products';
// Categories by business ID is called in all products when we select a particular business categiry
const ATG_CATEGORIES_BUSINESS_ID = '/product/all-products/categories';
const ATG_ANALYTICS_LOOKUPS = '/product/api/analytics/lookups';

// Commerce connector API is called in all our pes pages
const SPRYKER_COMMERCE_CONNECTOR_PATH = '/commerce-connector';
// product card main and secondary API is used called in range ,category listing and comparision pages.
const SPRYKER_PRODUCT_CARD_MAIN_PATH = '/products-card/main';
const SPRYKER_PRODUCT_CARD_SECONDARY_PATH = '/products-card/secondary';
// My products is called in range and pdp and also in category and subcategory listing products
const SPRYKER_MY_PRODUCTS_REST_URL = '/my-products';
const SPRYKER_ANALYTICS_LOOKUPS = '/analytics';
const SPRYKER_PRODUCTS_SUBSTITUTION = '/products-substitution';

const defaultPageLoadDataParams = [
    pageLoadDataParams.DIGITAL_PLATFORM,
    pageLoadDataParams.DIGITAL_PLATFORM_COUNTRY,
    pageLoadDataParams.ENVIRONMENT,
];
// eslint-disable-next-line @typescript-eslint/naming-convention
var pageLoadDataToAnalytics;
(function (pageLoadDataToAnalytics) {
    pageLoadDataToAnalytics["digitalPlatform"] = "digital_platform";
    pageLoadDataToAnalytics["digitalPlatformCountry"] = "digital_platform_country";
    pageLoadDataToAnalytics["environment"] = "environment";
})(pageLoadDataToAnalytics || (pageLoadDataToAnalytics = {}));
const addPageLoadDataInfoToAnalyticsEvent = (params = defaultPageLoadDataParams) => {
    var _a;
    const pageLoadData = (_a = window === null || window === void 0 ? void 0 : window.pesAnalytics) === null || _a === void 0 ? void 0 : _a.pageLoadData;
    return pageLoadData
        ? params.reduce((acc, curr) => {
            if (Object.getOwnPropertyDescriptor(pageLoadData, curr)) {
                acc[pageLoadDataToAnalytics[curr]] = pageLoadData[curr];
            }
            return acc;
        }, {})
        : {};
};

// Used for deciding which product-cart page to show. The one using ATG or the one using Spryker
var CartVersion;
(function (CartVersion) {
    CartVersion["v3"] = "v3";
    CartVersion["v2"] = "v2";
})(CartVersion || (CartVersion = {}));
const isBrowser = () => typeof window !== 'undefined';
const isV3 = () => Boolean(window.isV3);
const isPublicEnvironment = (isExecutedInBrowser = isBrowser) => {
    if (!isExecutedInBrowser())
        return false;
    if (window.isPublicPes)
        return true;
    try {
        return document.querySelector('body').getAttribute('is-public') === 'true';
    }
    catch (error) {
        console.warn('Could not check if code is executed from Public Environment', error);
        return false;
    }
};
const useReplatformedHMC = () => Boolean(window.isReplatformedHmc);
const productCartPageVersion = window.cartVersion;
const getBrandName = () => {
    if (window.isAsco)
        return 'ascopower';
    if (window.isApc)
        return 'apc';
    return 'se';
};
const buildURL$1 = ({ host, contextRoot, countryCode, languageCode, endpoint, }) => {
    let path = endpoint;
    if (languageCode) {
        path = `/${languageCode}${path}`;
    }
    if (countryCode) {
        /**
         * countryCode for China is
         * - lowercase (cn) if China-specific short-domain url is used as a host: 'https://schneider-electric.'
         *   which should be concatenated with countryCode without '/'
         * - uppercase (CN) if RP urls are used - in this case path should start with '/' symbol
         * Other countries' paths start with '/' symbol
         */
        path = `${countryCode !== 'cn' ? '/' : ''}${countryCode}${path}`;
    }
    if (contextRoot) {
        path = `${contextRoot}${path}`;
    }
    if (host) {
        path = `${host}${path}`;
    }
    return path;
};
const getSDLHeaderSelector = () => {
    if (isV3())
        return SDL_REDESIGN_HEADER_SELECTOR;
    // @ts-ignore
    if (window.isApc) {
        return SDL_HEADER_SELECTOR_APC;
    }
    return SDL_HEADER_SELECTOR;
};
const getHeaderHeight = () => {
    var _a, _b;
    return ((_b = (_a = document.querySelector(getSDLHeaderSelector())) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0);
};
const scrollToComponent = (el, options = {}) => {
    const { behavior = scrollBehavior.AUTO, offset = TAB_BAR_HEIGHT } = options;
    // A quick and dirty solution to the issue with scrolling to a component on sites of pes-catalog consumers:
    //  - MySe
    //  - MySchneider
    // See https://jira.se.com/browse/PESV3-27234 for details.
    if (document.querySelector(getSDLHeaderSelector())) {
        //  If there is the SDL header (we are on se.com or apc.com), we can scroll to the component while taking into account the header and the tabbar heights.
        const top = el.getBoundingClientRect().y + window.scrollY - getHeaderHeight() - offset;
        window.scrollTo({ top, behavior });
    }
    else {
        // If there is no header, we don't even try to guess the height of a consumer's header and just scroll the component into view.
        //  Most likely, it will be partially covered by the header, but we decided not to care about that for now.
        el.scrollIntoView();
    }
};
const consoleErrorMsg = (err, origin) => {
    console.error(`Error in ${origin}`, err);
};
const mergeUrlWithHost = (host, url) => {
    if ((host === null || host === void 0 ? void 0 : host.endsWith(SLASH)) && url.startsWith(SLASH)) {
        host.slice(0, host.length);
    }
    return `${host}${url}`;
};
const hasHttpOrHttps = (host) => {
    return host.includes(`${Protocol.HTTP}://`) || host.includes(`${Protocol.HTTPS}://`);
};
const validateHost = (host) => {
    return hasHttpOrHttps(host) ? host : '';
};

var FileSaver_min = createCommonjsModule(function (module, exports) {
(function(a,b){b();})(commonjsGlobal,function(){function b(a,b){return "undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c);},d.onerror=function(){console.error("could not download file");},d.send();}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send();}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"));}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b);}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof commonjsGlobal&&commonjsGlobal.global===commonjsGlobal?commonjsGlobal:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href);},4E4),setTimeout(function(){e(j);},0));}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else {var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i);});}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null;},k.readAsDataURL(b);}else {var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m);},4E4);}});f.saveAs=g.saveAs=g,(module.exports=g);});

//# sourceMappingURL=FileSaver.min.js.map
});

class ExcelService {
    constructor(excelSettings) {
        this.settings = {
            mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            extension: '.xlsx',
        };
        Object.assign(this.settings, excelSettings);
    }
    async getExcelJS() {
        try {
            if (!this.excelJSInstance)
                this.excelJSInstance = await window.System.import('exceljs');
            return { excelJS: this.excelJSInstance, error: null };
        }
        catch (error) {
            consoleErrorMsg(error, 'ExcelService -> getExcelJS');
            return { excelJS: null, error };
        }
    }
    // Order in values matters
    makeSingleItemRow(values, config) {
        const { emptyColumns, totalColumns, filler } = config;
        const cells = [];
        for (let index = 0; index < totalColumns; index++) {
            if (emptyColumns.includes(index) || index > values.length)
                cells.push(filler);
            else
                cells.push(values[index] || ' ');
        }
        return cells;
    }
    // Mutates worksheet
    hideEmptyColumns(worksheet) {
        const columns = worksheet.columnCount;
        for (let index = 1; index <= columns; index++) {
            let notEmpty = false;
            const eColumn = worksheet.getColumn(index);
            if (eColumn.hidden)
                continue;
            eColumn.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                if (rowNumber > 1 && String(cell.value).trim() !== '') {
                    notEmpty = true;
                }
            });
            eColumn.hidden = !notEmpty;
        }
    }
    // Mutates row
    populateRow(rowValues, row) {
        rowValues.forEach((value, index) => {
            // eslint-disable-next-line no-param-reassign
            row.getCell(index + 1).value = value;
        });
        return row;
    }
    async saveExcel(workbook, fileName) {
        try {
            const excelData = await workbook.xlsx.writeBuffer();
            const excelFile = new Blob([excelData], { type: this.settings.mimeType });
            FileSaver_min.saveAs(excelFile, fileName + this.settings.extension);
        }
        catch (error) {
            consoleErrorMsg(error, 'ExcelService -> saveExcel');
        }
    }
}
new ExcelService();

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

// for now just expose the builtin process global from node.js
var process_1 = commonjsGlobal.process;

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

var cookies = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var isURLSameOrigin = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process_1 !== 'undefined' && Object.prototype.toString.call(process_1) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData = function transformData(data, headers, fns) {
  var context = this || defaults_1;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults_1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};

const name = "axios";
const version = "0.21.4";
const description = "Promise based HTTP client for the browser and node.js";
const main = "index.js";
const scripts = {
	test: "grunt test",
	start: "node ./sandbox/server.js",
	build: "NODE_ENV=production grunt build",
	preversion: "npm test",
	version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
	postversion: "git push && git push --tags",
	examples: "node ./examples/server.js",
	coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
	fix: "eslint --fix lib/**/*.js"
};
const repository = {
	type: "git",
	url: "https://github.com/axios/axios.git"
};
const keywords = [
	"xhr",
	"http",
	"ajax",
	"promise",
	"node"
];
const author = "Matt Zabriskie";
const license = "MIT";
const bugs = {
	url: "https://github.com/axios/axios/issues"
};
const homepage = "https://axios-http.com";
const devDependencies = {
	coveralls: "^3.0.0",
	"es6-promise": "^4.2.4",
	grunt: "^1.3.0",
	"grunt-banner": "^0.6.0",
	"grunt-cli": "^1.2.0",
	"grunt-contrib-clean": "^1.1.0",
	"grunt-contrib-watch": "^1.0.0",
	"grunt-eslint": "^23.0.0",
	"grunt-karma": "^4.0.0",
	"grunt-mocha-test": "^0.13.3",
	"grunt-ts": "^6.0.0-beta.19",
	"grunt-webpack": "^4.0.2",
	"istanbul-instrumenter-loader": "^1.0.0",
	"jasmine-core": "^2.4.1",
	karma: "^6.3.2",
	"karma-chrome-launcher": "^3.1.0",
	"karma-firefox-launcher": "^2.1.0",
	"karma-jasmine": "^1.1.1",
	"karma-jasmine-ajax": "^0.1.13",
	"karma-safari-launcher": "^1.0.0",
	"karma-sauce-launcher": "^4.3.6",
	"karma-sinon": "^1.0.5",
	"karma-sourcemap-loader": "^0.3.8",
	"karma-webpack": "^4.0.2",
	"load-grunt-tasks": "^3.5.2",
	minimist: "^1.2.0",
	mocha: "^8.2.1",
	sinon: "^4.5.0",
	"terser-webpack-plugin": "^4.2.3",
	typescript: "^4.0.5",
	"url-search-params": "^0.10.0",
	webpack: "^4.44.2",
	"webpack-dev-server": "^3.11.0"
};
const browser = {
	"./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
const jsdelivr = "dist/axios.min.js";
const unpkg = "dist/axios.min.js";
const typings = "./index.d.ts";
const dependencies = {
	"follow-redirects": "^1.14.0"
};
const bundlesize = [
	{
		path: "./dist/axios.min.js",
		threshold: "5kB"
	}
];
const _resolved = "https://registry.npmjs.org/axios/-/axios-0.21.4.tgz";
const _integrity = "sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==";
const _from = "axios@0.21.4";
const pkg = {
	name: name,
	version: version,
	description: description,
	main: main,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies,
	browser: browser,
	jsdelivr: jsdelivr,
	unpkg: unpkg,
	typings: typings,
	dependencies: dependencies,
	bundlesize: bundlesize,
	_resolved: _resolved,
	_integrity: _integrity,
	_from: _from
};

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators$1
};

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios;

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios_1.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults_1);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios_1;

// Factory for creating new instances
axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

var axios_1 = axios$1;

// Allow use of default import syntax in TypeScript
var _default = axios$1;
axios_1.default = _default;

var axios = axios_1;

var Method;
(function (Method) {
    Method["GET"] = "GET";
    Method["POST"] = "POST";
    Method["PUT"] = "PUT";
    Method["DELETE"] = "DELETE";
})(Method || (Method = {}));
let axiosInstance;
function initBrowserAxios() {
    if (axiosInstance) {
        return;
    }
    axiosInstance = axios.create({
        // 120 sec timeout
        timeout: 120000,
        // cap the maximum content length we'll accept to 600MBs, just in case
        maxContentLength: 30 * 20 * 1000 * 1000,
        // follow up to 10 HTTP 3xx redirects
        maxRedirects: 10,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
}
const callAxios = async (config) => {
    try {
        const response = await axiosInstance.request(config);
        return response;
    }
    catch (error) {
        console.error(error);
        throw error;
    }
};

const getCommerceConnectorEndpointUrl = ({ host, contextRoot, countryCode, languageCode, }) => {
    if (isV3()) {
        return `${host}${SPRYKER_COMMERCE_CONNECTOR_PATH}`;
    }
    return buildURL$1({
        host,
        contextRoot,
        countryCode,
        languageCode,
        endpoint: ATG_COMMERCE_CONNECTOR_PATH,
    });
};
const commerceConnectorApiFetchers = {
    getCommerceConnector: async ({ host, contextRoot, countryCode, languageCode, }) => {
        const GET_COMMERCE_CONNECTOR_URL = getCommerceConnectorEndpointUrl({
            host,
            contextRoot,
            countryCode,
            languageCode,
        });
        const requestSettings = {
            method: Method.GET,
            url: GET_COMMERCE_CONNECTOR_URL,
        };
        if (isV3()) {
            requestSettings.params = {
                'country-code': countryCode,
                'language-code': languageCode,
                brand: getBrandName(),
            };
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
};

const getMyProductsCrudUrl = ({ contextRoot, countryCode, languageCode, urlRequestMethod, id, }) => {
    let myProductsRequestUrl = '';
    if (contextRoot) {
        contextRoot = `/${contextRoot}`;
    }
    switch (urlRequestMethod) {
        case 'getOrPost':
            myProductsRequestUrl = isV3() && productCartPageVersion === CartVersion.v3
                ? SPRYKER_MY_PRODUCTS_REST_URL
                : buildURL$1({
                    host: '',
                    contextRoot,
                    countryCode,
                    languageCode,
                    endpoint: ATG_MY_PRODUCTS_REST_URL,
                });
            break;
        case 'getByIdOrDelete':
            myProductsRequestUrl = isV3() && productCartPageVersion === CartVersion.v3
                ? `${SPRYKER_MY_PRODUCTS_REST_URL}/${id}`
                : buildURL$1({
                    host: '',
                    contextRoot,
                    countryCode,
                    languageCode,
                    endpoint: `${ATG_MY_PRODUCTS_REST_URL}/${id}`,
                });
            break;
        default:
            myProductsRequestUrl = isV3() && productCartPageVersion === CartVersion.v3
                ? SPRYKER_MY_PRODUCTS_REST_URL
                : buildURL$1({
                    host: '',
                    contextRoot,
                    countryCode,
                    languageCode,
                    endpoint: ATG_MY_PRODUCTS_REST_URL,
                });
    }
    return myProductsRequestUrl;
};
const myProductsApiFetchers = {
    postMyProducts: async ({ contextRoot, countryCode, languageCode, payload, }) => {
        const urlRequestMethod = 'getOrPost';
        const POST_MY_PRODUCTS_URL = getMyProductsCrudUrl({
            contextRoot,
            countryCode,
            languageCode,
            urlRequestMethod,
        });
        const requestSettings = {
            method: Method.POST,
            url: POST_MY_PRODUCTS_URL,
            withCredentials: true,
            data: payload,
        };
        if (isV3() && productCartPageVersion === CartVersion.v3) {
            requestSettings.params = {
                'country-code': countryCode,
                'language-code': languageCode,
                brand: getBrandName(),
            };
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
    getMyProducts: async ({ contextRoot, countryCode, languageCode, params, }) => {
        const urlRequestMethod = 'getOrPost';
        const API_GET_MY_PRODUCTS = getMyProductsCrudUrl({
            contextRoot,
            countryCode,
            languageCode,
            urlRequestMethod,
        });
        const requestSettings = {
            method: Method.GET,
            url: API_GET_MY_PRODUCTS,
            withCredentials: true,
        };
        if (isV3() && productCartPageVersion === CartVersion.v3) {
            requestSettings.params = Object.assign({ 'country-code': countryCode, 'language-code': languageCode, brand: getBrandName() }, params);
        }
        else {
            requestSettings.params = params;
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
    deleteMyProducts: async ({ contextRoot, countryCode, languageCode, params: { id }, }) => {
        const urlRequestMethod = 'getByIdOrDelete';
        const API_DELETE_MY_PRODUCTS = getMyProductsCrudUrl({
            contextRoot,
            countryCode,
            languageCode,
            urlRequestMethod,
            id,
        });
        const requestSettings = {
            method: Method.DELETE,
            url: API_DELETE_MY_PRODUCTS,
            withCredentials: true,
        };
        if (isV3() && productCartPageVersion === CartVersion.v3) {
            requestSettings.params = {
                'country-code': countryCode,
                'language-code': languageCode,
                brand: getBrandName(),
            };
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
};

const getProductCardMainEndpointUrl = ({ contextRoot, countryCode, languageCode, }) => {
    if (isV3())
        return SPRYKER_PRODUCT_CARD_MAIN_PATH;
    return buildURL$1({
        host: '',
        contextRoot,
        countryCode,
        languageCode,
        endpoint: ATG_PRODUCT_CARD_MAIN_PATH,
    });
};
const productsApiFetchers = {
    getProductsFetcher: async ({ contextRoot, countryCode, languageCode, params, }) => {
        const GET_PRODUCTS_URL = getProductCardMainEndpointUrl({
            contextRoot,
            countryCode,
            languageCode,
        });
        const requestSettings = {
            method: Method.GET,
            url: GET_PRODUCTS_URL,
        };
        if (isV3()) {
            requestSettings.params = Object.assign({ 'country-code': countryCode, 'language-code': languageCode, brand: getBrandName() }, params);
        }
        else {
            requestSettings.params = params;
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
};

const getTranslationURL$1 = (contextRoot, countryCode, languageCode) => {
    if (process_1.env.REACT_APP_DEV === 'mock')
        return 'http://localhost:3100/get-products-parameters';
    const brand = getBrandName();
    if (isV3()) {
        return buildURL$1({
            host: process_1.env.API_HOST,
            endpoint: `/products-comparison/characteristics?country-code=${countryCode}&language-code=${languageCode}&brand=${brand}`,
        });
    }
    return buildURL$1({
        host: process_1.env.API_HOST,
        contextRoot,
        countryCode,
        languageCode,
        endpoint: '/product/api/products/comparison/characteristics',
    });
};
const productsParametersApiFetchers = {
    getProductsParametersFetcher: async ({ contextRoot, countryCode, languageCode, params, }) => {
        const GET_PRODUCTS_PARAMETERS_URL = getTranslationURL$1(contextRoot, countryCode, languageCode);
        const response = await callAxios({
            method: Method.GET,
            url: GET_PRODUCTS_PARAMETERS_URL,
            params,
        });
        return response.data;
    },
};

const getProductInfoEndpointUrl = ({ contextRoot, countryCode, languageCode, }) => {
    if (isV3())
        return SPRYKER_PRODUCT_CARD_SECONDARY_PATH;
    return buildURL$1({
        host: '',
        contextRoot,
        countryCode,
        languageCode,
        endpoint: ATG_PRODUCT_CARD_ADDITION_PATH,
    });
};
const productsInfoApiFetchers = {
    getProductsInfoFetcher: async ({ contextRoot, countryCode, languageCode, params, }) => {
        const GET_PRODUCTS_INFO_URL = getProductInfoEndpointUrl({
            contextRoot,
            countryCode,
            languageCode,
        });
        const requestSettings = {
            method: Method.GET,
            url: GET_PRODUCTS_INFO_URL,
        };
        if (isV3()) {
            requestSettings.params = Object.assign({ 'country-code': countryCode, 'language-code': languageCode, brand: getBrandName() }, params);
        }
        else {
            requestSettings.params = params;
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
};

const getTranslationURL = (contextRoot, languageCode, countryCode) => {
    const brand = getBrandName();
    if (process_1.env.REACT_APP_DEV === 'mock')
        return 'http://localhost:3100/get-translations';
    if (isV3()) {
        return buildURL$1({
            host: process_1.env.API_HOST,
            endpoint: `/products-comparison/main?country-code=${countryCode}&language-code=${languageCode}&brand=${brand}`,
        });
    }
    return buildURL$1({
        host: process_1.env.API_HOST,
        contextRoot,
        countryCode,
        languageCode,
        endpoint: '/product/api/products/comparison/main',
    });
};
const translationsApiFetchers = {
    getTranslationsFetcher: async ({ contextRoot, countryCode, languageCode, params = { content: 'labels' }, }) => {
        const GET_TRANSLATIONS_URL = getTranslationURL(contextRoot, languageCode, countryCode);
        const response = await callAxios({
            method: Method.GET,
            url: GET_TRANSLATIONS_URL,
            params,
        });
        return response.data;
    },
};

const channelSightApiFetchers = {
    getProductsDataFeed: async ({ params }) => {
        const GET_PRODUCTS_FEED_URL = `${params.feedUrl}&pid=${params.productIds}`;
        const response = await callAxios({
            method: Method.GET,
            url: GET_PRODUCTS_FEED_URL,
        });
        return response.data;
    },
};

const bazaarVoiceApiFetchers = {
    getBazaarVoiceFetcher: async (params) => {
        const GET_BAZAARVOICE_URL = process_1.env.REACT_APP_DEV === 'mock'
            ? 'http://localhost:3100/get-bazaar-voice'
            : `${BAZAAR_VOICE_URL}?${params}`;
        const response = await callAxios({
            method: Method.GET,
            url: GET_BAZAARVOICE_URL,
        });
        return response.data;
    },
};

const productAvailabilityApiFetchers = {
    getProductAvailabilityFetcher: async ({ apcHost, params, }) => {
        const GET_PRODUCT_AVAILABILITY_URL = process_1.env.REACT_APP_DEV === 'mock'
            ? 'http://localhost:3100/get-product-availability'
            : buildURL$1({
                host: process_1.env.API_HOST,
                contextRoot: apcHost,
                endpoint: '/rest/model/schneider/catalog/availability/rest/ProductAvailabilityActor/pdpProductAvailabilityInfo',
            });
        const response = await callAxios({
            method: Method.GET,
            url: GET_PRODUCT_AVAILABILITY_URL,
            params,
        });
        return response.data;
    },
};

const buildCtaUrl = ({ contextRoot, countryCode, languageCode }) => {
    if (isV3()) {
        const endPoint = '/products-cta';
        const queryParams = `?country-code=${countryCode}&language-code=${languageCode}&brand=${getBrandName()}`;
        const url = endPoint + queryParams;
        return url;
    }
    return buildURL$1({
        host: process_1.env.API_HOST,
        contextRoot,
        countryCode,
        languageCode,
        endpoint: '/product/api/commerce-api/cta',
    });
};
const apcCtaApiFetchers = {
    getApcCtaFetcher: async ({ contextRoot, countryCode, languageCode }) => {
        const GET_APC_CTA_URL = process_1.env.REACT_APP_DEV === 'mock'
            ? 'http://localhost:3100/get-apc-cta'
            : buildCtaUrl({ contextRoot, countryCode, languageCode });
        const response = await callAxios({
            method: Method.GET,
            url: GET_APC_CTA_URL,
        });
        return response.data;
    },
};

const getAnalyticsLookupsEndpointUrl = ({ host, countryCode, languageCode, }) => {
    if (isV3())
        return `${host}${SPRYKER_ANALYTICS_LOOKUPS}`;
    return buildURL$1({
        host,
        countryCode,
        languageCode,
        endpoint: ATG_ANALYTICS_LOOKUPS,
    });
};
const analyticsApiFetchers = {
    getAnalyticsLookupFetcher: async ({ host, countryCode, languageCode }) => {
        const GET_PRODUCTS_INFO_URL = getAnalyticsLookupsEndpointUrl({
            host,
            countryCode,
            languageCode,
        });
        const requestSettings = {
            method: Method.GET,
            url: GET_PRODUCTS_INFO_URL,
        };
        if (isV3()) {
            requestSettings.params = {
                brand: getBrandName(),
                'country-code': countryCode,
                'language-code': languageCode,
            };
        }
        const response = await callAxios(requestSettings);
        return response.data;
    },
};

const getComparisonBundleURL = (contextRoot, languageCode, countryCode) => {
    const brand = getBrandName();
    if (isV3()) {
        return buildURL$1({
            host: process_1.env.API_HOST,
            endpoint: `/products-comparison/main?country-code=${countryCode}&language-code=${languageCode}&brand=${brand}`,
        });
    }
    return buildURL$1({
        host: process_1.env.API_HOST,
        contextRoot,
        countryCode,
        languageCode,
        endpoint: '/product/api/products/comparison/main',
    });
};
const comparisonBundleProductsApiFetchers = {
    getComparisonBundleProductsFetcher: async ({ contextRoot, countryCode, languageCode, params, }) => {
        const GET_COMPARISON_BUNDLE_PRODUCTS = getComparisonBundleURL(contextRoot, languageCode, countryCode);
        const response = await callAxios({
            method: Method.GET,
            url: GET_COMPARISON_BUNDLE_PRODUCTS,
            params,
        });
        return response.data;
    },
};

const ctaShoppableApiFetchers = {
    getShopSeRedirectionLink: async ({ url, query, store }) => {
        try {
            const response = await callAxios({
                method: Method.POST,
                url,
                data: { query },
                headers: {
                    store,
                },
            });
            return { result: response.data, error: null };
        }
        catch (error) {
            return { result: null, error };
        }
    },
};

const substitutionProductsApiFetchers = {
    getSubstitutionProducts: async ({ countryCode, languageCode, params, }) => {
        const requestSettings = {
            method: Method.GET,
            url: SPRYKER_PRODUCTS_SUBSTITUTION,
            params: Object.assign({ 'country-code': countryCode, 'language-code': languageCode, brand: getBrandName() }, params),
        };
        try {
            const response = await callAxios(requestSettings);
            return { productSubstitutionsResponse: response.data, error: null };
        }
        catch (error) {
            return { productSubstitutionsResponse: null, error };
        }
    },
};

const relatedProductsApiFetchers = {
    getRelatedProducts: async ({ countryCode, languageCode, productId, }) => {
        const GET_RELATED_PRODUCTS_URL = `/products/${productId}/related-products`;
        const requestSettings = {
            method: Method.GET,
            url: GET_RELATED_PRODUCTS_URL,
            params: {
                brand: getBrandName(),
                'country-code': countryCode,
                'language-code': languageCode,
            },
        };
        try {
            const response = await callAxios(requestSettings);
            return { relatedProductsResponse: response.data, error: null };
        }
        catch (error) {
            return { relatedProductsResponse: null, error };
        }
    },
};

initBrowserAxios();
const fetchers = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, productsApiFetchers), productsParametersApiFetchers), productsInfoApiFetchers), translationsApiFetchers), myProductsApiFetchers), commerceConnectorApiFetchers), channelSightApiFetchers), bazaarVoiceApiFetchers), productAvailabilityApiFetchers), apcCtaApiFetchers), analyticsApiFetchers), comparisonBundleProductsApiFetchers), ctaShoppableApiFetchers), substitutionProductsApiFetchers), relatedProductsApiFetchers);

var _a;
let lookups = (_a = window === null || window === void 0 ? void 0 : window.pesAnalytics) === null || _a === void 0 ? void 0 : _a.lookups;
const getLookupValueFunction = (lookupKey) => {
    return (key, id) => {
        if (!lookups) {
            return '';
        }
        let value = lookups[lookupKey][key] || '';
        if (id) {
            value = `${value.split(':')[0]}:${id}`;
        }
        return value;
    };
};
const getLookupValueAddCartLocation = getLookupValueFunction('addCartLocation');
const getLookupValueAddCartCTAType = getLookupValueFunction('addCartCTAType');
const getLookupValueProductLists = getLookupValueFunction('productLists');
const getLookupValueVirtualPageType = getLookupValueFunction('virtualPageTypes');
const getLookupValueVirtualPageName = getLookupValueFunction('virtualPageName');
const getLookupValuePageTabs = getLookupValueFunction('pageTabs');

export { ATG_CATEGORIES_BUSINESS_ID as A, SPRYKER_PRODUCT_CARD_SECONDARY_PATH as S, getLookupValueVirtualPageName as a, getLookupValuePageTabs as b, getLookupValueAddCartLocation as c, getLookupValueAddCartCTAType as d, getLookupValueVirtualPageType as e, fetchers as f, getLookupValueProductLists as g, hasHttpOrHttps as h, isV3 as i, getBrandName as j, getSDLHeaderSelector as k, isPublicEnvironment as l, mergeUrlWithHost as m, getHeaderHeight as n, buildURL$1 as o, ATG_PRODUCT_SOFTWARE_PATH as p, addPageLoadDataInfoToAnalyticsEvent as q, SPRYKER_PRODUCT_CARD_MAIN_PATH as r, scrollToComponent as s, useReplatformedHMC as u, validateHost as v };
